import { GetPartFinderBatchResponse, PartFinderBatch } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_ACTIVITY_QUERY_KEY } from '../part-finder-activity/query';
import { PART_FINDER_BATCH_QUERY_KEY, PART_FINDER_BATCHES_QUERY_KEY } from './query';

export const useClearPartFinderBatchName = (batchId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useMutation<PartFinderBatch, AxiosApiError, void>({
    mutationFn: async () => {
      const response = await api.tenants.clearPartFinderBatchName(tenantId, batchId);
      return response.data.partFinderBatch;
    },
    onSuccess: updated => {
      queryClient.setQueryData<GetPartFinderBatchResponse>([PART_FINDER_BATCH_QUERY_KEY, batchId], {
        partFinderBatch: updated,
      });
      queryClient.invalidateQueries({ queryKey: [PART_FINDER_BATCHES_QUERY_KEY], exact: false });
      queryClient.invalidateQueries({ queryKey: [PART_FINDER_ACTIVITY_QUERY_KEY], exact: false });
    },
  });
};
